import {connect} from 'react-redux';
import LocationGroupsScreen from '../../components/screens/LocationGroupsScreen';

const LocationGroupsScreenContainer = connect(
    null,
    null
)(LocationGroupsScreen);

export default LocationGroupsScreenContainer;